// extracted by mini-css-extract-plugin
module.exports = {"dotBase":"Dot_dotBase__34SYv","dotLarge":"Dot_dotLarge__1tpB1"};